import { types } from "../action-types";

const initialState = {
  loading: false,
  hrmDetails: [],
  error: false,
};

const getHRMDetailsReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.HRM_DETAILS_INIT:
      return {
        ...state,
        loading: true,
      };

    case types.HRM_DETAILS_SUCCESS:
      return {
        ...state,
        loading: false,
        hrmDetails: action.payload?.data,
        error: false,
      };
    case types.HRM_DETAILS_FAILURE:
      return {
        ...state,
        loading: false,
        hrmDetails: [],
        error: true,
      };
    default:
      return state;
  }
};

export default getHRMDetailsReducer;
